module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/layout/layout-right-panel-2-66351653094227b927d116e4596e0749.svg";